export default __webpack_public_path__ + "agent_bg4310132.png";